import _implicitStylesheets from "./codeBlock.css";
import _implicitScopedStylesheets from "./codeBlock.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="line-number${0}"${2}>${"t1"}</div>`;
const stc0 = {
  classMap: {
    "code-block": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "code-container": true
  },
  key: 1
};
const stc2 = {
  classMap: {
    "gutter": true
  },
  attrs: {
    "aria-hidden": "true"
  },
  key: 2
};
const stc3 = {
  classMap: {
    "code": true,
    "hljs": true
  },
  context: {
    lwc: {
      dom: "manual"
    }
  },
  key: 6
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {k: api_key, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, i: api_iterator, h: api_element} = $api;
  return [api_element("div", stc0, [api_element("div", stc1, [api_element("div", stc2, api_iterator($cmp.lineNumbers, function (line) {
    return api_static_fragment($fragment1, api_key(4, line.key), [api_static_part(1, null, api_dynamic_text(line.number))]);
  })), api_element("pre", {
    attrs: {
      "tabindex": "0",
      "role": "group",
      "aria-label": $cmp.codeRegionLabel
    },
    key: 5
  }, [api_element("code", stc3)])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1j1kal3eduh";
tmpl.legacyStylesheetToken = "undefined-_codeBlock";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
